/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'solevBtn': {
    width: 250.244,
    height: 250,
    viewBox: '0 0 1025 1024',
    data: '<defs/><path pid="0" d="M512.654 1023.998a511.791 511.791 0 0 1-199.308-983.52 512.106 512.106 0 0 1 398.616 943.458 508.787 508.787 0 0 1-199.308 40.062zm0-943.459c-238.369 0-431.668 193.3-431.668 431.668s193.3 431.667 431.668 431.667S944.32 750.575 944.32 512.207 751.022 80.539 512.654 80.539z" _fill="#3296fa"/><path pid="1" d="M427.522 715.521a40.062 40.062 0 0 1-28.043-12.019L207.18 511.205a40.367 40.367 0 0 1 57.089-57.088L427.522 618.37l339.525-339.525a40.367 40.367 0 0 1 57.088 57.088l-368.57 367.568a40.062 40.062 0 0 1-28.043 12.02z" _fill="#3296fa"/>'
  }
})
